import {useCallback, useEffect, useState} from 'react';

import jwt_decode from 'jwt-decode';
import {useCookies} from 'react-cookie';

import {UserContextType} from './UserContext';
import {EMPION_COOKIE_ID, ROLE_COMPANY_ADMIN} from '../../lib/constants';
import {CompanyAdminRoleData, User} from '../../types/User';

export const useUserData = (): UserContextType => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  //Maybe we can make a custom hook for all cookie logic.
  const [cookies] = useCookies([EMPION_COOKIE_ID]);

  useEffect(() => {
    const user: User | null = cookies[EMPION_COOKIE_ID];

    if (!!user?.role?.data && isValidCookie(user)) {
      setCurrentUser(user);
    }
    setIsLoading(false);
  }, [cookies]);

  // Copying logic for now, but should be moved to custom hook for cookies
  const isValidCookie = (cookie: any): boolean => {
    if (!cookie) {
      return false;
    }

    const token = cookie.token;

    const decoded_token: any = jwt_decode(token);
    const token_subject = decoded_token.sub;

    return token_subject === cookie.id;
  };

  const userContextLogin = (userData: User) => {
    // Perform sign-in logic here, e.g., authenticate with backend
    // Once signed in, update the user state
    setCurrentUser(userData);
  };

  const userContextLogout = useCallback(() => {
    // Perform sign-out logic here
    // Once signed out, update the user state
    setCurrentUser(null);
  }, []);

  const isUserLoggedIn = useCallback(() => {
    return !!currentUser;
  }, [currentUser]);

  const isRoleCompany = currentUser?.role?.type === ROLE_COMPANY_ADMIN;
  const isContractSigned = isRoleCompany && (currentUser?.role.data as CompanyAdminRoleData).contractSigned;

  return {
    currentUser,
    userContextLogin,
    userContextLogout,
    isUserLoggedIn,
    isLoading,
    isContractSigned,
    isRoleCompany,
  };
};
